import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const displayTimezone = () => localStorage.getItem('assetflow-timezone') || 'Asia/Dubai';
export function setDisplayTimezone(value) {
  new Intl.DateTimeFormat('en-US', { timeZone: value });
  localStorage.setItem('assetflow-timezone', value);
  window.dispatchEvent(new Event('assetflow:timezone-changed'));
}
export function formatDate(date) {
  if (!date || Number.isNaN(new Date(date).getTime())) return '—';
  return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric', timeZone: /^\d{4}-\d{2}-\d{2}$/.test(String(date)) ? 'UTC' : displayTimezone() }).format(new Date(date));
}
export function formatDateTime(date, precision) {
  if (!date || Number.isNaN(new Date(date).getTime())) return '—';
  if (precision === 'date' || /^\d{4}-\d{2}-\d{2}$/.test(String(date))) return formatDate(String(date).slice(0, 10));
  return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: displayTimezone(), timeZoneName: 'short' }).format(new Date(date));
}
export const safeCSVCell = value => {
  let text = String(value ?? '');
  // Leading controls are included so pasted spreadsheet formula text stays inert.
  // eslint-disable-next-line no-control-regex
  if (typeof value === 'string' && /^[\s\u0000-\u001f]*[=+\-@]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
};

export function generateId() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function slugify(str) {
  return str.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');
}

export function truncate(str, length = 50) {
  if (str.length <= length) return str;
  return str.slice(0, length) + '...';
}

export function downloadCSV(data, filename) {
  if (!data || data.length === 0) return;
  
  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.map(safeCSVCell).join(','),
    ...data.map(row => headers.map(header => safeCSVCell(row[header])).join(','))
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
}

